var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 68,
    viewBox: "0 0 78 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 34C0 15.2223 15.2223 0 34 0H43.0667C61.8443 0 77.0667 15.2223 77.0667 34C77.0667 52.7777 61.8443 68 43.0667 68H34C15.2223 68 0 52.7777 0 34Z",
    fill: "#F9B44E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2342_50)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1885 41.3734C50.1959 40.3734 47.7921 38.9141 46.6259 38.326C45.1071 37.5611 44.9821 37.4986 43.7883 38.3854C42.992 38.9772 42.4626 39.506 41.5307 39.3072C40.5988 39.1085 38.5738 37.9879 36.8006 36.2205C35.0275 34.4531 33.8418 32.3694 33.6424 31.4407C33.443 30.512 33.9806 29.9889 34.5668 29.1908C35.3931 28.0658 35.3306 27.8783 34.6243 26.3597C34.0737 25.1785 32.5718 22.7973 31.568 21.8099C30.4942 20.7493 30.4942 20.9368 29.8023 21.2243C29.239 21.4612 28.6986 21.7493 28.1879 22.0848C27.1879 22.7492 26.6329 23.301 26.2447 24.1304C25.8566 24.9597 25.6822 26.904 27.6866 30.5451C29.6911 34.1862 31.0974 36.048 34.008 38.9504C36.9187 41.8527 39.1569 43.4133 42.4289 45.2482C46.4765 47.515 48.029 47.0731 48.8609 46.6857C49.6928 46.2982 50.2472 45.7482 50.9128 44.7482C51.2493 44.2384 51.538 43.6986 51.7754 43.1358C52.0635 42.4465 52.251 42.4465 51.1885 41.3734Z",
    stroke: "#1C2752",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2342_50"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(25 20)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPhone);
export default __webpack_public_path__ + "static/media/IconPhone.243a385c9675925340f6fca8b45663ff.svg";
export { ForwardRef as ReactComponent };